import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MapService } from '../../map.service';
import { MessageService } from '../../message.service';
import { SearchService } from '../../search.service';
import { TabService } from '../../tab.service';
import { UserService } from '../../user.service';
import {Clipboard} from '@angular/cdk/clipboard';
import { JobInfo } from '../../data/jobinfo';
import { FileInfo, WorkspaceService } from '../../workspace.service';
import { environment } from '../../../environments/environment';
import { Record } from '../../data/record';
import { WMSRecord } from '../../data/wmsrecord';
import { ColorMapEntry, Sld } from '../../data/sld';
import { StacItem } from '../../data/stacitem';
import { CdkDragMove } from '@angular/cdk/drag-drop';

@Component({
  standalone: false,  // this is now required when using NgModule
  selector: 'app-explorerbottombar',
  templateUrl: './explorerbottombar.component.html',
  styleUrls: ['./explorerbottombar.component.css'],
})
export class ExplorerbottombarComponent implements OnInit {

  recordDetails:string|undefined = undefined;
  recordTitle:string|undefined = undefined;
  recordQuicklook:string|undefined = undefined;

  visibleJob: JobInfo|undefined = undefined;

  slds: Sld[] = [];
  editorSld: Sld|undefined = undefined;
  templateSld: Sld|undefined = undefined;
  sldEditorItem: WMSRecord|undefined = undefined;
  sldEditorVisible = false;

  constructor(public tabService: TabService, public userService: UserService, 
    public searchService: SearchService, public mapService: MapService,
    public workspaceService: WorkspaceService,
    public messageService: MessageService, private clipboard: Clipboard, private ref: ChangeDetectorRef) { }

  ngOnInit(): void {
  }

  copyResourceUrlToClipboard(rec:Record) {
    
    if (rec.itemHref) {
      this.clipboard.copy(rec.itemHref);
    } else if (rec.resourceUrl) {
      this.clipboard.copy(rec.resourceUrl);
    } else {
      this.clipboard.copy('');
    }
  }

  addResourceWMSLayer(rec:WMSRecord) {
    this.mapService.addWMSLayer(rec);
  }

  removeResourceWMSLayer(rec:WMSRecord) {
    this.mapService.removeWMSLayer(rec);
  }

  zoomToWMSLayer(rec:WMSRecord) {
    this.mapService.zoomToWGS84(rec.bbox);
  }

  showRecordDetails(rec:Record): void {
    let details = this.searchService.getRecordDetails(rec)?.subscribe((data: any) => {
      if (data) {
        //console.log(feed);
        let id = data['id'];
        if (id) {
          //console.log(entry);
          let prettyPrint = JSON.stringify(data,null,2);
          //console.log(prettyPrint);
          this.recordDetails = prettyPrint;
          this.recordTitle = id;
          this.recordQuicklook = undefined;
          if (data.assets && data.assets.QUICKLOOK && data.assets.QUICKLOOK.href) {
            this.recordQuicklook = data.assets.QUICKLOOK.href;
          } else if (rec.collection == 'ENMAP_HSI_L2A') {
            // ENMAP quicklooks available here at least on 25.2.2026
            this.recordQuicklook = 'https://geoservice.dlr.de/eoc/oseo/quicklook?parentIdentifier=ENMAP_HSI_L2A&uid=' + id;
          }
          this.ref.markForCheck();
        }
      }
      //let prettyPrint = JSON.stringify(data,null,2);
      //console.log(prettyPrint);
      //this.selectedProcessDetails = data;
      //for (let key in data.inputs) {
      //    data.inputs[key].tag = key;
      //    this.selectedProcessInputs.push(data.inputs[key])
      //}
    }, (error:any)=>{
      this.messageService.addMessage('ERROR in getRecordDetails');
    });
    
  }

  hideRecordDetails(): void {
    this.recordTitle = undefined;
    this.recordDetails = undefined;
    this.recordQuicklook = undefined;
  }

  jobHasWMSLayer(job:JobInfo) {
    return this.mapService.hasCollectionWMSLayer(job.jobID);
  }

  removeJobWMSLayers(job:JobInfo) {
    this.mapService.removeCollectionWMSLayers(job.jobID);
  }

  setJobWMSLayersOpacity(job:JobInfo, event:Event) {
    const opacity = (event.target as HTMLInputElement).valueAsNumber;
    job.wmsopacity = opacity;
    this.mapService.setCollectionWMSLayersOpacity(job.jobID, opacity);
  }

  setWMSLayerOpacity(rec:WMSRecord, event:Event) {
    const opacity = (event.target as HTMLInputElement).valueAsNumber;
    rec.wmsopacity = opacity;
    this.mapService.setWMSLayerOpacity(rec, opacity);
  }

  showJobDetails(job:JobInfo) {
    console.log(job);
    if (job.stacItems) {
      // Data has been retrieved already
      this.visibleJob = job;
    } else if (job.status == 'successful') {
      this.userService.getJobResult(job.jobID)?.subscribe({
        next: (data) => {
          //console.log(data);
          let stacId = data['id'];
          if (stacId) {
            // Get the STAC Item data
            this.userService.getStacCollectionItems(stacId)?.subscribe({
              next: (stacData) => {
                this.visibleJob = job;
                this.visibleJob.stacData = stacData;

                // Get S3 file data
                this.workspaceService.listFiles('processing-results/' + stacId, this.gotJobResults.bind(this));
              },
              error: (e) => {
                this.userService.handleError(e, 'Failed to get job result collection for ' + job.jobID);
              }
            });
          }
        },
        error: (e) => {
          this.userService.handleError(e, 'Failed to get job ' + job.jobID);
        }
      });
    }
  }

  gotJobResults(data:FileInfo[]): void {
    let stacItems:StacItem[] = [];
    if (this.visibleJob && this.visibleJob.stacData && 'features' in this.visibleJob.stacData) {
      for (let item of this.visibleJob.stacData.features) {
        // Build the structured UI objects from the STAC json data
        //console.log(item);
        let stacItem = StacItem.parse(item,data,environment.userWorkspacePrefix + this.userService.userInfo?.userName,this.mapService);

        //console.log(stacItem);
        if (stacItem != null) {
          //for (const [key, value] of Object.entries(item)) {
          //  console.log(`${key}: ${value}`);
          //}
          stacItems.push(stacItem);
        }
      }
    }

    if (this.visibleJob) {
      this.visibleJob.stacItems = stacItems;
    }
    this.ref.markForCheck();
  }

  hideJobDetails(): void {
    this.visibleJob = undefined;
  }

  showSldEditor(rec:WMSRecord): void {
    this.sldEditorItem = rec;
    if (rec.sld) {
      this.editorSld = rec.sld;
    } else {
      this.editorSld = new Sld(); // TODO: should get from asset
      this.editorSld.colormap.push(new ColorMapEntry('0', '#000000'));
      this.editorSld.colormap.push(new ColorMapEntry('255', '#FFFFFF'));
    }
    this.sldEditorVisible = true;
  }

  hideSldEditor(): void {
    this.sldEditorVisible = false;
    this.sldEditorItem = undefined;
    this.editorSld = undefined;
  }

  hideFeatureInfoView(): void {
    this.mapService.featureInfoChartData = undefined;
  }

  onSldUpdated(item:WMSRecord) {
    this.removeResourceWMSLayer(item);
    this.addResourceWMSLayer(item);
  }

  copyResultUrlToClipboard(file:FileInfo) {
    if (file.itemHref) {
      this.clipboard.copy(file.itemHref);
    } else if (file.resourceUrl) {
      this.clipboard.copy(file.resourceUrl);
    } else {
      this.clipboard.copy('');
    }
  }

   copyStacItemHrefToClipboard(item:StacItem) {
    if (item.href) {
      this.clipboard.copy(item.href);
    } else {
      this.clipboard.copy('');
    }
  }

  getFilenameFromLayerName(value:string|undefined) {
    if (value) {
      const index = value.indexOf(":");
      return index === -1 ? "" : value.slice(index + 1);
    }
    return "";
  }


/*
onDragMoved(event: CdkDragMove) {
  console.log(event);
  const el = event.source.element.nativeElement;

  const rect = el.getBoundingClientRect();
  console.log(rect);
  const maxX = window.innerWidth - rect.width;
  const maxY = window.innerHeight - rect.height;

  let x = rect.left;
  let y = rect.top;

  // Prevent going left
  if (x < 100 - rect.width) {
    x = 100 - rect.width;
  }
  // Prevent going up
  if (y < 100 - rect.height) {
    y = 100 - rect.height;
  }
y = 0;
  //x = Math.max(0, Math.min(x, maxX));
  //y = Math.max(0, Math.min(y, maxY));

  el.style.transform = `translate3d(${x}px, ${y}px, 0)`;
}
*/

}
